import React from 'react';
import ReactDOM from 'react-dom/client';
import {NextUIProvider} from "@nextui-org/react";
import App from './App';
import './index.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Impressum} from "./Impressum";
import {Datenschutz} from "./Datenschutz";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <NextUIProvider>
            <main className="dark text-foreground bg-ubiBackgroundLight min-h-screen">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<App/>}/>
                        <Route path="/impressum" element={<Impressum/>}/>
                        <Route path="/datenschutz" element={<Datenschutz/>}/>
                    </Routes>
                </BrowserRouter>
            </main>
        </NextUIProvider>
    </React.StrictMode>
);
